import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Container = styled.table`
  border-collapse: collapse;
  margin-bottom: 1rem;
`;

export const Row = styled.tr`
  border-bottom: 1px solid transparent;
  cursor: ${(props) => (props.onClick != null ? "pointer" : "default")};
  &:nth-child(even) {
    background-color: ${(props) =>
			props.zebra ? "rgba(20,20,20,0.1)" : "transparent"};
  }
  &:hover {
    border-bottom-color: rgba(255, 255, 255, 0.15);
  }
  background-color: ${(props) =>
		props.drawAttention ? "rgba(102,255,204,0.05)" : ""};
`;

export const Cell = styled.td`
  padding: 0.5rem;
  cursor: ${(props) => (props.onClick != null ? "pointer" : "default")};
`;

export const NoDataCell = styled(Cell)`
	text-align: center;
	font-style: italic;
	opacity: 50%;
	padding: 1rem;
`;

// TODO: Show cursor if any onClick handler attached

/** Table renders a data table with simple support for zebra striping */
const Table = ({ children, zebra = false }) => {
	return <Container zebra={zebra}>{children}</Container>;
};

Table.propTypes = {
	// If true, applies subtle zebra-striping to rows
	zebra: PropTypes.bool,
	// Any provided children
	children: PropTypes.any,
};

export default Table;
